import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import classNames from "classnames";
// config

// image
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconArrowDownLight from "../../../../images/icon_arrow_down_light/icon_arrow_down_light.svg";
import IconArrowRight from "../../../../images/icon_arrow_right/icon_arrow_right.svg";
import IconArrowDown from "../../../../images/icon_arrow_down/icon_arrow_down.svg";

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledAccordion = styled((props) => (
  <Accordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  // border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const StyledAccordionSummary = styled((props) => (
  <AccordionSummary
    expandIcon={
      <img
        className="accordion-toggle-icon"
        src={IconArrowRight}
        alt="expanded icon"
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "transparent",
  flexDirection: "row-reverse",
  "&.MuiAccordionSummary-root": {
    padding: "0 0 0 4px",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: "4px",
    // marginTop: "8px",
    // marginBottom: "8px",
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  "&.MuiAccordionDetails-root": {
    // paddingLeft: "0",
    paddingRight: "0",
    paddingTop: "0",
    paddingBottom: "0",
  },
}));

//
const AccordionMain = ({
  darkMode,
  accordionProps,
  summaryChildren,
  summaryProps,
  detailsChildren,
  detailsProps,
}) => {
  // style
  const classes = useStyles();
  // props
  const { onAccordionChange, ...restAccordionProps } = accordionProps;
  // local state

  const [expanded, setExpanded] = useState(true);

  const handleChange = (e, newExpanded) => {
    const classname = e.target.className;
    if (!(classname && typeof classname === "string")) return;
    // 僅針對 accordion icon, summary-text 偵測, 不偵測 tail icon
    const listenClassNames = [
      "accordion-toggle-icon",
      "summary-head",
      "summary-head-text",
    ];
    let hasClassName = false;
    listenClassNames.forEach((name) => {
      if (classname.indexOf(name) > -1) hasClassName = true;
    });
    if (hasClassName) setExpanded(newExpanded);
    // if (onAccordionChange) onAccordionChange(e, newExpanded);
  };

  return (
    <StyledAccordion
      expanded={expanded}
      onChange={handleChange}
      {...restAccordionProps}
      sx={{
        backgroundColor: "inherit",
      }}
    >
      <StyledAccordionSummary
        aria-controls="panel1d-content"
        id="panel1d-header"
        {...summaryProps}
        sx={{
          "& .MuiAccordionSummary-content": {
            backgroundColor: "inherit",
            color: darkMode ? "#f7f8fa" : "inherit",
          },
        }}
      >
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box flexGrow={1} className="summary-head">
            <Typography className="summary-head-text" variant="body2">
              {summaryChildren.text}
            </Typography>
          </Box>
          {summaryChildren.tail}
        </Box>
      </StyledAccordionSummary>
      <StyledAccordionDetails {...detailsProps}>
        {detailsChildren}
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};

AccordionMain.propTypes = {
  darkMode: PropTypes.bool,
  summaryChildren: PropTypes.objectOf(PropTypes.any),
  detailsChildren: PropTypes.node,
  accordionProps: PropTypes.objectOf(PropTypes.any),
  summaryProps: PropTypes.objectOf(PropTypes.any),
  detailsProps: PropTypes.objectOf(PropTypes.any),
};

AccordionMain.defaultProps = {
  darkMode: false,
  summaryChildren: null,
  detailsChildren: null,
  accordionProps: {},
  summaryProps: {},
  detailsProps: {},
};

export default AccordionMain;
